<script type="text/babel">
import { mapGetters, mapActions, mapMutations } from 'vuex';
import objectPath from 'object-path';
/* eslint-disable */
export default {
    name: 'ImportMixin',
    data () {
        return {
            templateIdMap: {}
        };
    },
    computed: {
        ...mapGetters({
            products : 'getProducts',
            prices : 'getAllPrices',
            layouts : 'getLayouts',
            templates: 'getTemplates',
            templateGroups: 'getTemplateGroups'
        }),
        productIds () {
            return this.products.map(({id}) => id);
        },
        layoutIds () {
            return this.layouts.map(({id}) => id);
        },
        pricesIds () {
            return this.prices.map(({id}) => id);
        }
    },
    methods: {
        ...mapMutations(['addAlert']),
        ...mapActions([
            'addProductAsync',
            'updateProductAsync',
            'addLayoutAsync',
            'putLayoutAsync',
            'addTemplateAsync',
            'addTemplateGroupAsync',
            'getTemplateJSONAsync',
            'getTemplateByTemplateIdAsync',
            'addTemplateAsync',
            'updateTemplateGroupAsync',
            'updateTemplateAsync',
            'getAllTemplatesAsync',
            'removeTemplateAsync',
            'deleteProductAsync',
            'getProductGroupListAsync',
            'getPricesAsync',
            'getProductListAsync',
            'getTemplateGroupsAsync',
            'removeTemplateGroupAsync',
            'fetchLayoutsAsync',
            'deleteLayoutAsync'
        ]),
        async deleteConfig () {
            const confirmation = window.confirm('DO YOU WANT TO DELETE ALL DATA?');
            if(!confirmation) {
                return;
            }
            try {
                await this.$utils.resolvePromises(this.templates.map(template => this.removeTemplateAsync(template)));
                await this.$utils.resolvePromises(this.templateGroups.map(group => this.removeTemplateGroupAsync(group)));
                await this.$utils.resolvePromises(this.products.map(product => this.deleteProductAsync(product.id)));
                await this.$utils.resolvePromises(this.layouts.map(({id}) => this.deleteLayoutAsync({id, disableDispatch: true})));
                this.$store.commit('addAlert', {
                    title: 'Successfully ',
                    type: 'success',
                    body: 'deleted the configuration'
                });
            } catch (err) {
                this.$store.commit('addAlert', {
                    title: 'Failed ',
                    type: 'danger',
                    body: 'to delete configuration or part of it'
                });
                throw new Error(err);
            }
            await this.getAll();
        },
        async getAll () {
            await this.getTemplateGroupsAsync();
            await this.getAllTemplatesAsync();
            await this.getPricesAsync();
            await this.getProductListAsync();
            await this.fetchLayoutsAsync();
            await this.getProductGroupListAsync();
        },
        async exportAll () {
            try {
                await this.getAll();
                let templateJsonMap = await this.extractJsonFilesFromTemplates(this.templates);
                this.$utils.exportData(
                    {
                        data: {
                            products: this.products,
                            prices: this.prices,
                            layouts: this.layouts,
                            templates: this.templates,
                            templateJsonMap: templateJsonMap,
                            templateGroups: this.templateGroups
                        },
                        fileName: `CPH_config_${Date.now()}`
                    }
                );
            } catch (err) {
                throw new Error(err);
            }
        },
        async exportTemplates () {
            let templateJsonMap = await this.extractJsonFilesFromTemplates(this.templates);
            this.$utils.exportData(
                {
                    data: {
                        templates: this.templates,
                        templateJsonMap: templateJsonMap,
                        templateGroups: this.templateGroups
                    },
                    fileName: `CPH_templates_${Date.now()}`
                }
            );
        },
        templateIds: (templates) => templates.map(({id}) => id),
        templateGroupIdMap: (templateGroups) => templateGroups.map(({id}) => ({oldId: id, newId: ''})),
        importAll () {
            this.importData(this.$refs.fileInput, this.handleGlobalImport, {global: true});
        },
        importData (inputElement, callback, options) {
            inputElement.click();
            inputElement.onchange = (evt) => this.handleFileSelect(evt, callback, options);
        },
        importProducts (product, {idList = []}) {
            if((idList.indexOf(product.id) > -1)) {
                return this.updateProductAsync({product: product, productPrice: product.price, price: product.price || 0, disableFetch: true});
            } else {
                return this.addProductAsync({product: product, price: product.price || 0, disableFetch: true});
            }
        },
        async extractJsonFilesFromTemplates (templates) {
            let promises = [];
            templates.forEach(template => {
                promises.push(this.getTemplateByTemplateIdAsync(template));
            });
            let promiseRes = await this.$utils.resolvePromises(promises);
            promises = [];
            promiseRes.forEach((data) => {
                promises.push(this.getTemplateJSONAsync(data[0]));
            });
            promiseRes = await this.$utils.resolvePromises(promises);
            let result = {};
            promiseRes.forEach((data, index) => {
                result[templates[index].id] = data[0];
            });
            return result;
        },
        async importTemplates ({templates, templateJsonMap, templateGroups}) {
            let promises = [];
            let templateGroupIdMap = this.templateGroupIdMap(templateGroups);
            templateGroups.forEach(group => {
                if(this.templateGroups.findIndex(item => item.id === group.id) > -1) {
                    promises.push(this.updateTemplateGroupAsync(group));
                } else {
                    promises.push(this.addTemplateGroupAsync(group));
                }
            });
            let result = await this.$utils.resolvePromises(promises);
            result = result.map((data) => data[0].group);
            promises = [];
            result.forEach((res, index) => templateGroupIdMap[index].newId = res.id);
            for(let key in templateJsonMap) {
                templateJsonMap[key].groups.forEach(group => {
                    let idx = templateGroupIdMap.findIndex(groupMapItem => groupMapItem.oldId === group.id);
                    if(idx > -1) {
                        group.id = templateGroupIdMap[idx].newId;
                    }
                })
            }
            templates.forEach(template => {
                if(this.templates.findIndex(tpl => tpl.id === template.id) > -1) {
                    promises.push(this.updateTemplateAsync(Object.assign({}, template, templateJsonMap[template.id])));
                } else {
                    promises.push(this.addTemplateAsync(Object.assign({}, template, templateJsonMap[template.id])));
                }
            });
            await this.$utils.resolvePromises(promises);
            this.$store.commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `imported ${promises.length} templates`
            });
            return templateGroupIdMap;
        },
        handleLayoutImports ({layouts}) {
            if (Array.isArray(layouts)) {
                layouts.forEach(layout => {
                    this.importLayoutToDb(layout, {});
                })
            } else {
                this.importLayoutToDb(layouts, {});
            }
        },
        importLayoutToDb (layout, {idList = []}) {
            let {resultArray} = this.$utils.getNestedKeyPaths(layout, 'groups');
            if(resultArray.length > 0) {
                resultArray.forEach(({path}) => {
                    let groupsPath = path.join('.');
                    let groups = objectPath.get(layout, groupsPath);
                    if(groups) {
                        groups.forEach(group => {
                            if(this.templateIdMap[group.id]) {
                                group.id = this.templateIdMap[group.id];
                            }
                        });
                        objectPath.set(layout, groupsPath, groups);
                    }
                })
            }
            try {
                if((idList.indexOf(layout.id) > -1)) {
                    return this.putLayoutAsync({layout, disableFetch: true});
                } else {
                    return this.addLayoutAsync({layout, disableFetch: true});
                }
            } catch (err) {
                throw new Error(err);
            }
        },
        handleFileSelect (evt, callback, options) {
            let files = evt.target.files; // FileList object
            for (let file of files) {
                if(file.name.indexOf('.json') > -1 || file.type === 'application/json') {
                    this.readFile(file, callback, options);
                } else {
                    //eslint-disable-next-line
                    console.log('incorrect file extension');
                }
            }
        },
        readFile (file, callback, options) {
            let reader = new FileReader();
            reader.onload = (e) => {
                try {
                    this.parseAndImport(e.target.result, callback, options);
                } catch (ex) {
                    //eslint-disable-next-line
                    console.log('exception when trying to parse json = ' + ex);
                }
            };
            reader.readAsText(file);
        },
        async resolveArrayOfPromises (arrayOfPromises) {
            if(arrayOfPromises.length === 0) {
                return false;
            }
            return await this.$utils.resolvePromises(arrayOfPromises);
        },
        importLayoutList () {
            this.importData(this.$refs.fileInput, this.handleLayoutImports, {});
        },
        async handleGlobalImport (data) {
            let templateJsonMapDefault = data.templateJsonMap ? data.templateJsonMap : await this.extractJsonFilesFromTemplates(this.templates);
            let {
                products = this.products,
                prices = this.prices,
                layouts = this.layouts,
                templates = this.templates,
                templateJsonMap = templateJsonMapDefault,
                templateGroups = this.templateGroups
            } = data;
            const arrayOfPromises = [];
            let layoutsImported = false;
            let layoutIds = [];
            let layoutResponse = [];
            let templateGroupMap = [];
            if(!this.$utils.isNil(templates)) {
                templateGroupMap = await this.importTemplates({templates, templateJsonMap, templateGroups});
                templateGroupMap.forEach(group => this.templateIdMap[group.oldId] = group.newId);
            }
            if(!this.$utils.isNil(layouts) && layouts.length > 0) {
                layoutResponse = await this.parseAndImport(layouts, this.importLayoutToDb, {idList: this.layoutIds, parsed: true});
                this.$store.commit('addAlert', {
                    title: 'Successfully ',
                    type: 'success',
                    body: `imported ${layouts.length} layouts`
                });
                if(layoutResponse.err) {
                    this.$store.commit('addAlert', {
                        title: 'Failed ',
                        type: 'danger',
                        body: 'to import data'
                    });
                    return;
                }
                layoutsImported = true;
                layoutIds = layoutResponse.map(r => r.oldId);
                layouts.filter(layout => layout.id).forEach(layout => {
                    let sibling = this.$utils.getNestedProperty(layout, ['jsonData', 'metadata', 'layoutRotatedSibling']);
                    if(sibling) {
                        let index = layoutIds.findIndex(item => item === sibling.id);
                        let layoutsNewIdIndex = layoutIds.findIndex(item => item === layout.id);
                        if(index > -1) {
                            sibling.id = layoutResponse[index].id || sibling.id;
                            layout.jsonData.metadata.layoutRotatedSibling = sibling;
                            layout.id = layoutResponse[layoutsNewIdIndex].id;
                            arrayOfPromises.push(this.putLayoutAsync({...layout, disableFetch: true}));
                        }
                        
                    }
                });
                await this.resolveArrayOfPromises(arrayOfPromises);
            }
            
            if(!this.$utils.isNil(products) && products.length > 0) {
                if(layoutsImported) {
                    if(!this.$utils.isNil(products) && products.length > 0) {
                        products.forEach(product => product.availableLayouts
                            .forEach(layout => {
                                let index = layoutIds.findIndex(item => item === layout.id);
                                if(index > -1) {
                                    layout.id = layoutResponse[index].id || layout.id;
                                }
                            })
                        );
                    }
                }
                if(!this.$utils.isNil(prices)) {
                    products.forEach(product => product.price = prices[product.id].price);
                }
                await this.parseAndImport(products, this.importProducts, {idList: this.productIds, parsed: true});
                this.$store.commit('addAlert', {
                    title: 'Successfully ',
                    type: 'success',
                    body: `imported ${products.length} products`
                });
                return true;
            }
        },
        async parseAndImport (data, callback, options) {
            let imported = !options.parsed ? JSON.parse(data) : data;
            if(options.global) {
                return callback(imported, options);
            }
            let arrayOfPromises = [];
            if(Array.isArray(imported)) {
                imported.forEach(item => {
                    arrayOfPromises.push(callback(item, options));
                });
                return await this.$utils.resolvePromises(arrayOfPromises);
                
            } else {
                if(imported) {
                    return callback(imported, options);
                }
            }
        },
        async getApiData () {
            const promiseArray = [];
            for(let route in this.$store.state.config) {
                if(this.$store.state.config.hasOwnProperty(route)) {
                    promiseArray.push(
                        this.$store.dispatch('createActions', this.$store.state.config[route])
                    );
                }
            }
            //eslint-disable-next-line
            const regex = new RegExp(/\[|\]|(\\n)|\\/g);
            let res = await this.$utils.resolvePromises(promiseArray);
            this.$utils.exportData({
                data: this.$utils.flatten(res).join(',\n').replace(regex, ''),
                fileName: 'api',
                format: 'js',
                stringify: false
            });
        }
    }
};

</script>
